"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unwrapAsData = void 0;
var types_1 = require("../types.js");
function unwrapAsData(t) {
    while (t[0] === types_1.PrimType.AsData)
        t = t[1];
    return t;
}
exports.unwrapAsData = unwrapAsData;
